import React from "react";
import { Route, RouteComponentProps, Switch, Redirect } from "react-router-dom";

import { AutomationHome } from "./AutomationHome";
import { AutomationEdit } from "./AutomationEdit";
import { Environments } from "./Environments";
import {
  CREATE_AC,
  CREATE_ELECTRICAL_PANEL,
  CREATE_ENVIRONMENT,
  CREATE_LIGHTS,
  CREATE_REFRIGERATION,
  CREATE_ENGINES,
  CREATE_HEATING_WATER,
  CREATE_OTHER_CARGO,
  CREATE_ROUTER,
  CREATE_ROUTER_MANUAL,
  CREATE_PHOTOVOLTAIC,
} from "routers/routePaths";
import { CreateEnvironment } from "./CreateEnvironment";
import { CreateAC } from "./CreateAC";
import { CreateElectricalPanel } from "./CreateElectricalPanel";
import { CreateLighting } from "./CreateLighting";
import { CreateRefrigeration } from "./CreateRefrigeration";
import { CreateEngines } from "./CreateEngines";
import { WifiQualityAuto } from "./WifiQualityAuto";
import { WifiQualityManual } from "./WifiQualityManual";
import { CreateHeatingWater } from "./CreateHeatingWater";
import { CreateOtherCargo } from "./CreateOtherCargo";
import { CreatePhotovoltaic } from "./CreatePhotovoltaic";

export const AutomationRouter = ({
  match: { path },
  location: { state },
}: RouteComponentProps) => {
  return (
    <Switch>
      <Route exact path={CREATE_ENVIRONMENT} component={CreateEnvironment} />
      <Route exact path={`${CREATE_AC}/:environmentId?`} component={CreateAC} />
      <Route exact path={`${CREATE_ROUTER}`} component={WifiQualityAuto} />
      <Route
        exact
        path={`${CREATE_ROUTER_MANUAL}`}
        component={WifiQualityManual}
      />
      <Route
        exact
        path={`${CREATE_ELECTRICAL_PANEL}`}
        component={CreateElectricalPanel}
      />
      <Route exact path={`${CREATE_LIGHTS}`} component={CreateLighting} />
      <Route
        exact
        path={`${CREATE_REFRIGERATION}`}
        component={CreateRefrigeration}
      />
      <Route exact path={`${CREATE_ENGINES}`} component={CreateEngines} />
      <Route
        exact
        path={`${CREATE_HEATING_WATER}`}
        component={CreateHeatingWater}
      />
      <Route
        exact
        path={`${CREATE_OTHER_CARGO}`}
        component={CreateOtherCargo}
      />
      <Route
        exact
        path={`${CREATE_PHOTOVOLTAIC}`}
        component={CreatePhotovoltaic}
      />
      <Route
        exact
        path={`${path}/environments/:status?`}
        component={Environments}
      />
      <Route exact path={`${path}/edit/:id`} component={AutomationEdit} />
      <Route exact path={`${path}/`} component={AutomationHome} />
      <Route exact path={path}>
        <Redirect to={{ pathname: `${path}/`, state }} />
      </Route>
    </Switch>
  );
};
